import { BASE_URL, FIREBASE_CONFIG } from './config'
import USER_ENDPOINTS from './user/endpoints'
import VENDOR_ENDPOINTS from './vendor/endpoints'

export { BASE_URL, FIREBASE_CONFIG }

export const ENDPOINTS = {
  ...USER_ENDPOINTS,
  ...VENDOR_ENDPOINTS
}
